import { shopifyEnv, shopifyGraphqlEndpoint } from "./env";

interface GraphqlError {
    message: string;
}

interface GraphqlResponse<T> {
    data?: T;
    errors?: GraphqlError[];
}

export interface UserError {
    field?: string[] | null;
    message: string;
}

export class ShopifyApiError extends Error {}

export async function shopifyFetch<T>(query: string, variables?: Record<string, unknown>): Promise<T> {
    if (!shopifyEnv.storeDomain || !shopifyEnv.storefrontToken) {
        throw new ShopifyApiError(
            "Shopify ist nicht konfiguriert. Setze REACT_APP_SHOPIFY_STORE_DOMAIN und REACT_APP_SHOPIFY_STOREFRONT_TOKEN in .env.local."
        );
    }

    const response = await fetch(shopifyGraphqlEndpoint(), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": shopifyEnv.storefrontToken,
            Accept: "application/json",
        },
        body: JSON.stringify({ query, variables }),
    });

    if (!response.ok) {
        throw new ShopifyApiError(`Shopify Storefront API antwortete mit ${response.status} ${response.statusText}`);
    }

    const json: GraphqlResponse<T> = await response.json();

    if (json.errors && json.errors.length > 0) {
        throw new ShopifyApiError(json.errors.map((e) => e.message).join("; "));
    }
    if (!json.data) {
        throw new ShopifyApiError("Shopify Storefront API lieferte keine Daten zurück.");
    }
    return json.data;
}

/** Throws if a mutation payload carries userErrors, e.g. cartLinesAdd's response.cartLinesAdd.userErrors. */
export function assertNoUserErrors(userErrors: UserError[] | undefined | null, context: string): void {
    if (userErrors && userErrors.length > 0) {
        throw new ShopifyApiError(`${context}: ${userErrors.map((e) => e.message).join("; ")}`);
    }
}
